export default __webpack_public_path__ + "static/media/Justine.448012b9.mp3";